export default "/smolpool.20a5efdb25fbb19d8e6b103cc795286b.png";